<template>

  <HeaderYachts :section="section" />

  <div class="banner__slide" v-if="pageItem">
    
    <video v-if="pageVideo" class="banner__content" muted="" webkit-playsinline="" playsinline="" loop="" autoplay>
    </video>
    
    <img v-if="pageImg" :src="pageImg" :alt="pageItem.title" class="banner__content" >

  </div>

</template>

<script>
  import HeaderYachts from './headers/HeaderYachts.vue'

  export default {
    name: 'HomePage',
    data() {
      return {
        section: this.$store.getters.section,
        pageItems: this.$store.getters['filelist/pageItems'],
      }
    },
    computed: {
      pageItem() {
        if (!this.pageItems) return false
        return this.$store.getters['filelist/pagesFromSection'](this.section)
      },
      pageVideo() {
        if (!this.pageItem || !this.pageItem.mainVideo) return null
        return this.pageItem.mainVideo
      },
      pageImg() {
        return this.pageItem.companyImage
      },
    },
    methods: {
    },
    created() {
      document.body.classList.remove('yacht-page')
    },
    components: {
      HeaderYachts,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
